import { render, staticRenderFns } from "./ChildrenEntityView.vue?vue&type=template&id=55988cd4&scoped=true&"
import script from "./ChildrenEntityView.vue?vue&type=script&lang=js&"
export * from "./ChildrenEntityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55988cd4",
  null
  
)

export default component.exports